import { Component, OnInit } from '@angular/core';
import { ApiService } from '../api-service/api.service';
import { ProfileService } from '../profile-service/profile.service'
import { ClientConfigService } from '../client-config-service/client-config.service'
import swal from 'sweetalert2';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.less']
})
export class SidebarComponent implements OnInit {

	private staffProfile:any
  private clientConfig:any
  public showMobileMenu = false;
  private marketplaceUrl = environment.marketplaceUrl

  	constructor(private apiService : ApiService, private profileService: ProfileService, private clientConfigService: ClientConfigService) { }

  	ngOnInit() {

      this.profileService.profile.subscribe((value)=>{
        this.staffProfile = value    
      })

      this.clientConfigService.clientConfig.subscribe((value)=>{
        this.clientConfig = value
      })
  		

 	}


	logout() {

		swal({   
            title: "Are you sure you want to logout?",   
            type: "warning",   
            showCancelButton: true,   
            confirmButtonColor: "#149fba",   
            confirmButtonText: "Yes, logout", 
        })
        .then((selection) => {
            
            //API Logout
            this.apiService.logout();

        })
        .catch(swal.noop);
        
	}

}



// WEBPACK FOOTER //
// /Users/mattspringbett/sites/cycler/apollo-admin/src/src/app/sidebar/sidebar.component.ts